import React, { useState } from 'react';

export const Base64PdfView: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [base64String, setBase64String] = useState<string>('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConvert = () => {
    if (!file) {
      setError("Please select a PDF file.");
      return;
    }
    setIsProcessing(true);
    setError(null);
    try {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        // Result is in the format "data:application/pdf;base64,..."
        // We can either extract just the base64 part or keep the data URI
        const base64Part = result.split(',')[1];
        setBase64String(base64Part || '');
        setIsProcessing(false);
      };
      reader.onerror = () => {
        setError("Failed to read file.");
        setIsProcessing(false);
      };
      reader.readAsDataURL(file);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : String(err));
      setIsProcessing(false);
    }
  };

  const handleCopy = () => {
    void navigator.clipboard.writeText(base64String);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>PDF to Base64</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--color-text-secondary)' }}>Convert your PDF document into a Base64 encoded string securely in your browser.</p>
        </div>
        <button onClick={() => { handleConvert(); }} disabled={isProcessing} style={{ padding: '0.5rem 1rem', background: 'var(--color-accent)', color: 'var(--color-on-accent)', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600 }}>
          {isProcessing ? 'Converting...' : 'Convert to Base64'}
        </button>
      </div>
      {error && <div style={{ color: 'red', marginBottom: '1rem', padding: '0.5rem', background: '#ffebee', borderRadius: '4px' }}>{error}</div>}
      
      <div style={{ flex: 1, display: 'flex', gap: '1rem', height: '100%' }}>
        <div style={{ flex: 1, border: '2px dashed var(--color-border)', borderRadius: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
          <input 
            type="file" 
            accept="application/pdf" 
            onChange={(e) => {
              const file = e.target.files?.[0];
            if (file) {
                setFile(file);
              }
            }}
            style={{ marginBottom: '1rem' }}
          />
          {file && <span>{file.name}</span>}
        </div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <textarea
            readOnly
            value={base64String}
            placeholder="Base64 output will appear here..."
            style={{ flex: 1, padding: '1rem', borderRadius: '8px', border: '1px solid var(--color-border)', resize: 'none', fontFamily: 'monospace' }}
          />
          <button onClick={handleCopy} disabled={!base64String} style={{ marginTop: '0.5rem', padding: '0.5rem', background: 'var(--color-bg-secondary)', color: 'var(--color-text-primary)', border: '1px solid var(--color-border)', borderRadius: '4px', cursor: 'pointer' }}>
            Copy to Clipboard
          </button>
        </div>
      </div>
    </div>
  );
};
